import { Button } from '@deere/fuel-react';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';

export default function HomePage() {
    return (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center'}}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent:'center', background:'#FFFFFF', padding:'2%'}}>
            <div style={{ display: 'flex', flexDirection:'column', alignItems: 'center', justifyContent: 'center'}}>
                <div>
                    <ReportProblemOutlinedIcon sx={{ fontSize:100, color: "#666666" }} />
                </div>
                <div style={{fontSize:'x-large', fontWeight:'bold', color:'#454545'}}>
                    Apologies, it appears you lack the required access to view this application
                </div>
                <div style={{fontSize:'large', color:'#666666', margin:'2%'}}>
                    Please contact your system administrator or support team for assistance.
                </div>
                <div><Button variant='primary'>Contact Support</Button></div>
            </div>
        </div>
        </div>
    )
}